/* eslint-disable */
import { produce } from "immer";
import {
  LIVING_STANDARD_FETCH_START,
  LIVING_STANDARD_FETCH_SUCCESS,
  LIVING_STANDARD_FETCH_FAILURE,
} from "../actions/types";

const livingStandards = (
  state = {
    fetching: false,
    data: {},
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case LIVING_STANDARD_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case LIVING_STANDARD_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case LIVING_STANDARD_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default livingStandards;
